<template>
    <div>
         <a-button @click="showModal">
                                        <a-icon type="upload" /> افزودن مهمانان
                                    </a-button>

        <a-modal width="1000px" v-model="visible" title=" مهمانان سمینار" on-ok="handleOk">
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>

            </template>
            <form @submit.prevent="addData($event)">

            <div class="row text-right">
              <div class="col-md-2">
                   <a-button target="_blank" href="https://asan-tahator.com/importGuest.xlsx">
                                        <a-icon type="upload" />  مشاهده نمونه
                                    </a-button>
                                    &nbsp;
                </div>
                <div class="col-md-5">
                    <div class="form-group text-right">
                   
                        <label for="">  آپلود فایل اکسل</label>

                        <input id="file" name="file" type="file" class="form-control">
                    </div>
                </div>
  
                <div class="col-md-5">
                    <div class="form-group text-right">
               
                        <label for="">    انتخاب سمینار</label>

                        <select v-model="seminar_id" class="form-control">
                                                    <option  value="">انتخاب</option>
                            <option v-for="item in seminars" :value="item.id">{{ item .title}}</option>
                        </select>

                    </div>
                </div>
               

                <div class="mt-1">
                    <button type="submit" class="btn btn-fill btn-outline-success ">
                            ذخیره
                        </button>
                </div>
            </div>
            </form>
         
        </a-modal>
    </div>
</template>
<script>
    export default {
        props: {
            seminar: Object,
        },
        data() {
            return {
                loading: false,
                visible: false,
                seminar_id: "",
                seminars:[],
            };
        },
        methods: {
              async getSeminars() {
                let _this = this;
                let url = '/seminars/all';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.seminars = response.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            addData(event) {
                 let _this = this;
                let formData = new FormData();
                formData.append("file", document.getElementById('file').files[0]);
                formData.append("seminar_id",this.seminar_id);
                axios.post("/seminars/call/importCall", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }).then(function(response) {
                        _this.$toast.success("فایل اکسل با موفقیت ذخیره شد.   ");

                    })
                    .catch(function(err) {
                        _this.$toast.error("فایل ارسالی  صحیح  نیست.   ");
                        _this.$root.handleAxiosError(err);
                    });
            },
         
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
                this.$emit('getData')

            },
        },
        mounted(){
            this.getSeminars()
        }
    };
</script>
